var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, useContext, useEffect, useRef, } from 'react';
import classNames from 'classnames';
import CardButtonWrapper from './CardButtonWrapper';
import CardContent from './CardContent';
import CardFooter from './CardFooter';
import CardHeader from './CardHeader';
import { CardContext, CardContextObject } from './context/CardContext';
import { getChildCardElementType } from './helpers/getChildCardElementType';
import { CardContainer, CardMain, CardWrapper } from './styles/card.styled';
const CardComponent = ({ children, reference, class: className, inactive = false, onOpen, padding = true, onCollapse, onUncollapse, }) => {
    const isMounted = useRef(false);
    const { collapsable, collapsed, dataTest, useRedesign, useBackground } = useContext(CardContextObject);
    const cardClassNames = classNames('PONCHO-card', {
        'PONCHO-card--inactive': inactive,
        'PONCHO-card--new': useRedesign,
    }, className);
    const childrenArray = Children.toArray(children);
    const cardHeader = [...childrenArray].filter((child) => getChildCardElementType(child) === 'CARD_HEADER');
    const cardContent = [...childrenArray].filter((child) => getChildCardElementType(child) === 'CARD_CONTENT');
    const cardFooter = [...childrenArray].filter((child) => getChildCardElementType(child) === 'CARD_FOOTER');
    const cardButtonWrapper = [...childrenArray].filter((child) => getChildCardElementType(child) === 'CARD_BUTTON_WRAPPER');
    useEffect(() => {
        if (onOpen !== undefined) {
            if (process.env.NODE_ENV === 'development') {
                throw new Error(`Card prop onOpen has been renamed to onUncollapse, please update your implementation as support will be dropped in the future.`);
            }
        }
    }, [onOpen]);
    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }
        if (!reference) {
            return;
        }
        const event = { target: { id: `${reference}-toggle-collapse` } };
        if (!collapsed && onOpen) {
            onOpen(event);
        }
        if (!collapsed && onUncollapse) {
            onUncollapse(event);
        }
        if (collapsed && onCollapse) {
            onCollapse(event);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [collapsed]);
    return (React.createElement(CardContainer, { className: cardClassNames, id: reference, "$inactive": inactive, "$padding": padding, "$useRedesign": useRedesign, "data-test": `${dataTest}-container` },
        React.createElement(CardMain, { className: "PONCHO-card__main", "$collapsable": collapsable, "$collapsed": collapsed, "$useRedesign": useRedesign, "data-test": dataTest },
            cardHeader,
            React.createElement(CardWrapper, { className: "PONCHO-card__wrapper", "$useRedesign": useRedesign, "$useBackground": useBackground, "data-test": `${dataTest}-wrapper` },
                cardContent,
                cardButtonWrapper,
                cardFooter))));
};
const Card = (_a) => {
    var { children, class: className } = _a, props = __rest(_a, ["children", "class"]);
    const { reference, inactive, padding, mode, onOpen, onModeChange, onCollapse, onUncollapse } = props, contextProps = __rest(props, ["reference", "inactive", "padding", "mode", "onOpen", "onModeChange", "onCollapse", "onUncollapse"]);
    return (React.createElement(CardContext, Object.assign({ onModeChange: onModeChange, mode: mode }, contextProps),
        React.createElement(CardComponent, { class: className, reference: reference, inactive: inactive, padding: padding, onOpen: onOpen, onCollapse: onCollapse, onUncollapse: onUncollapse }, children)));
};
Card.Content = CardContent;
Card.Footer = CardFooter;
Card.Header = CardHeader;
Card.ButtonWrapper = CardButtonWrapper;
export default Card;
//# sourceMappingURL=Card.js.map